import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 16CB0045-C446-4384-8031-B3CEDDE555EE
 * name purse-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/purse-outline.svg
 * tags
 */
export const PurseOutlineIcon = createSvgIcon(<><path d="M19,11L20,19H4L5,11H19M14,3H10L8,5V9H4.7A1.65,1.65 0 0,0 3,10.5L2,19.1A1.74,1.74 0 0,0 3.7,21H20.3A1.74,1.74 0 0,0 22,19.1L21,10.5A1.65,1.65 0 0,0 19.3,9H16V5L14,3M10,9V5H14V9" /></>, 'PurseOutlineIcon');
export default PurseOutlineIcon